/* Cart upsell — two cards matched to the product in the cart.
   Source order: same product type → shared tags → Shopify related. Real products,
   real prices, nothing fabricated. Shared core; store glue appended below. */
(function () {
  'use strict';
  var SEL = '[data-cart-upsell]';
  var cache = {};           // cartKey → hydrated items
  var pending = null;
  var HEADERS = { Accept: 'application/json' };
  // market-aware: /fi-fi/, /da-dk/ … so titles and prices come back in the visitor's language + currency
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function box() { return document.querySelector(SEL); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }

  function money(cents, fmt) {
    fmt = fmt || '{{amount}}';
    var n = cents / 100;
    function fixed(dec, thou, decSep) { var s = n.toFixed(dec); var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0]; }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fixed(2, ',', '.');
        case 'amount_no_decimals': return fixed(0, ',', '.');
        case 'amount_with_comma_separator': return fixed(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(0, '.', ',');
        case 'amount_with_space_separator': return fixed(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fixed(2, "'", '.');
        default: return fixed(2, ',', '.');
      }
    });
  }

  function getJSON(url) { return fetch(url, { headers: HEADERS }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }

  function suggest(q, field) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10' +
      '&resources[options][fields]=' + field + '&resources[options][unavailable_products]=hide';
    return getJSON(url).then(function (d) { return (d && d.resources && d.resources.results && d.resources.results.products) || []; });
  }

  function candidates(cart) {
    var lead = cart.items[0];
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var out = [], seen = {};
    function push(list, exactType) {
      list.forEach(function (p) {
        if (!p || seen[p.id] || inCart[p.id] || p.available === false) return;
        if (exactType && (p.type || p.product_type) !== exactType) return;
        seen[p.id] = 1; out.push(p);
      });
    }
    var chain = Promise.resolve();
    if (lead.product_type) {
      chain = chain.then(function () { return suggest(lead.product_type, 'product_type'); })
        .then(function (r) { push(r, lead.product_type); if (out.length < 2) push(r, null); });
    }
    chain = chain.then(function () {
      if (out.length >= 2) return;
      return getJSON(ROOT + 'products/' + lead.handle + '.js').then(function (pj) {
        if (!pj) return;
        var vendor = (pj.vendor || '').toLowerCase();
        var tags = (pj.tags || []).filter(function (t) { return t && !/^rum-|^cat-|^nordisk|^hemlund/i.test(t) && t.toLowerCase() !== vendor; }).slice(0, 3);
        return tags.reduce(function (p, tag) {
          return p.then(function () { if (out.length >= 2) return; return suggest(tag, 'tag').then(function (r) { push(r, null); }); });
        }, Promise.resolve());
      });
    });
    chain = chain.then(function () {
      if (out.length >= 2) return;
      return getJSON(ROOT + 'recommendations/products.json?product_id=' + lead.product_id + '&limit=6&intent=related')
        .then(function (d) { push((d && d.products) || [], null); });
    });
    return chain.then(function () { return out.slice(0, 2); });
  }

  function hydrate(p) {
    return getJSON(ROOT + 'products/' + p.handle + '.js').then(function (j) {
      if (!j) return null;
      // cheapest available variant → the card shows the product's real "from" price
      var v = (j.variants || []).filter(function (x) { return x.available; }).sort(function (a, b) { return a.price - b.price; })[0];
      if (!v) return null;
      return { id: j.id, title: j.title, url: ROOT + 'products/' + j.handle, image: j.featured_image || (j.images && j.images[0]) || '',
        variantId: v.id, price: v.price, compare: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0, multi: (j.variants || []).length > 1 };
    });
  }

  function render(b, items, lead) {
    var fmt = b.getAttribute('data-money-format') || '{{amount}}';
    var html = '<div class="cu__head"><p class="cu__heading">' + esc(b.getAttribute('data-heading')) + '</p>' +
      '<p class="cu__lead">' + esc(lead.product_title) + '</p></div><div class="cu__list">';
    items.forEach(function (it) {
      var cta = it.multi
        ? '<a class="cu__btn" href="' + esc(it.url) + '">' + esc(b.getAttribute('data-choose')) + '</a>'
        : '<button type="button" class="cu__btn" data-cart-upsell-add="' + it.variantId + '">' + esc(b.getAttribute('data-add')) + '</button>';
      html += '<div class="cu__card">' +
        '<a class="cu__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="72" height="72">' : '') + '</a>' +
        '<div class="cu__body"><a class="cu__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        '<div class="cu__price"><span>' + esc(money(it.price, fmt)) + '</span>' + (it.compare ? '<s>' + esc(money(it.compare, fmt)) + '</s>' : '') + '</div></div>' +
        cta + '</div>';
    });
    b.innerHTML = html + '</div>';
    b.setAttribute('data-filled', '1');
    b.hidden = false;
  }

  function refresh() {
    var b = box(); if (!b) return Promise.resolve();
    if (pending) return pending;
    pending = getJSON(ROOT + 'cart.js').then(function (cart) {
      var b2 = box(); if (!b2) return;
      if (!cart || !cart.items.length) { b2.hidden = true; b2.removeAttribute('data-filled'); b2.innerHTML = ''; return; }
      var key = cart.items.map(function (i) { return i.product_id; }).join('|');
      if (b2.getAttribute('data-filled') && b2.getAttribute('data-key') === key) return;
      b2.setAttribute('data-key', key);
      var lead = cart.items[0];
      var got = cache[key] ? Promise.resolve(cache[key]) : candidates(cart).then(function (cs) {
        return Promise.all(cs.map(hydrate)).then(function (hs) { return hs.filter(Boolean); });
      }).then(function (items) { cache[key] = items; return items; });
      return got.then(function (items) {
        var b3 = box(); if (!b3) return;
        if (!items.length) { b3.hidden = true; return; }
        render(b3, items, lead);
      });
    }).catch(function () {}).then(function () { pending = null; });
    return pending;
  }

  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    var store = window.CartUpsellStore || {};
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (store.sections) { body.sections = store.sections; body.sections_url = window.location.pathname; }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.status) throw new Error(j.description || 'add failed'); if (store.afterAdd) store.afterAdd(j); else refresh(); })
      .catch(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn.getAttribute('data-cart-upsell-add'), btn);
  });

  window.CartUpsell = { refresh: refresh, add: addVariant };
})();

/* Nordisk Marknad (Impulse, NM drawer) glue: Impulse rebuilds line items via cart:build; the
   drawer script dispatches cart:updated after every change. After a one-tap add, rebuild and
   open the drawer through Impulse's own events. */
(function () {
  'use strict';
  window.CartUpsellStore = {
    afterAdd: function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:updated')); }, 120);
    }
  };
  function go() { window.CartUpsell && window.CartUpsell.refresh(); }
  document.addEventListener('cart:updated', go);
  document.addEventListener('cart:open', function () { setTimeout(go, 150); });
  var toggle = document.querySelector('.js-drawer-open-cart');
  if (toggle) toggle.addEventListener('click', function () { setTimeout(go, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
